// Mock data for ShipitNow delivery super-app

export const CURRENCIES = [
  { code: 'CAD', symbol: 'CA$', name: 'Canadian Dollar', rate: 1.35 },
  { code: 'USD', symbol: '$',   name: 'US Dollar',       rate: 1 },
  { code: 'EUR', symbol: '€',   name: 'Euro',            rate: 0.92 },
  { code: 'GBP', symbol: '£',   name: 'British Pound',   rate: 0.79 },
  { code: 'NGN', symbol: '₦',   name: 'Nigerian Naira',  rate: 1450 },
  { code: 'INR', symbol: '₹',   name: 'Indian Rupee',    rate: 83.2 },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham',      rate: 3.67 },
  { code: 'JPY', symbol: '¥',   name: 'Japanese Yen',    rate: 156.4 },
  { code: 'AUD', symbol: 'A$',  name: 'Australian Dollar', rate: 1.53 },
];

export const CATEGORIES = [
  { id: 'restaurants', name: 'Restaurants', icon: 'UtensilsCrossed', color: 'bg-orange-50 text-orange-600' },
  { id: 'grocery', name: 'Grocery', icon: 'ShoppingBasket', color: 'bg-emerald-50 text-emerald-600' },
  { id: 'pharmacy', name: 'Pharmacy', icon: 'Pill', color: 'bg-rose-50 text-rose-600' },
  { id: 'flowers', name: 'Flowers', icon: 'Flower2', color: 'bg-pink-50 text-pink-600' },
  { id: 'alcohol', name: 'Drinks', icon: 'Wine', color: 'bg-purple-50 text-purple-600' },
  { id: 'convenience', name: 'Convenience', icon: 'Store', color: 'bg-blue-50 text-blue-600' },
  { id: 'electronics', name: 'Electronics', icon: 'Cpu', color: 'bg-slate-100 text-slate-700' },
  { id: 'gifts', name: 'Gifts', icon: 'Gift', color: 'bg-amber-50 text-amber-600' },
];

export const PROMOS = [
  {
    id: 'p1',
    title: '50% off your first order',
    subtitle: 'New customers only • Use code: SWIFT50',
    bg: 'from-emerald-500 to-emerald-700',
  },
  {
    id: 'p2',
    title: 'Free delivery this weekend',
    subtitle: 'On orders over $25',
    bg: 'from-slate-800 to-slate-950',
  },
  {
    id: 'p3',
    title: 'Groceries in 15 minutes',
    subtitle: 'Fresh produce, doorstep delivered',
    bg: 'from-orange-500 to-rose-600',
  },
];

export const VENDORS = [
  {
    id: 'v1',
    name: 'Napoli Pizza Co.',
    category: 'restaurants',
    cuisine: 'Italian',
    rating: 4.8,
    reviews: 1240,
    deliveryTime: '20–30 min',
    deliveryFee: 2.99,
    minOrder: 10,
    distance: '1.2 km',
    cover: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxwaXp6YXxlbnwwfHx8fDE3NzkyMTUxNDh8MA&ixlib=rb-4.1.0&q=85',
    logo: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?crop=entropy&cs=srgb&fm=jpg&w=120&q=70',
    tags: ['Pizza', 'Pasta', 'Italian'],
    promo: '20% off',
  },
  {
    id: 'v2',
    name: 'Sakura Sushi House',
    category: 'restaurants',
    cuisine: 'Japanese',
    rating: 4.9,
    reviews: 2105,
    deliveryTime: '25–35 min',
    deliveryFee: 3.49,
    minOrder: 15,
    distance: '2.4 km',
    cover: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxzdXNoaXxlbnwwfHx8fDE3NzkyMTUxNDh8MA&ixlib=rb-4.1.0&q=85',
    logo: 'https://images.unsplash.com/photo-1553621042-f6e147245754?crop=entropy&cs=srgb&fm=jpg&w=120&q=70',
    tags: ['Sushi', 'Asian', 'Japanese'],
    promo: 'Free delivery',
  },
  {
    id: 'v3',
    name: 'Smash & Stack Burgers',
    category: 'restaurants',
    cuisine: 'American',
    rating: 4.6,
    reviews: 880,
    deliveryTime: '15–25 min',
    deliveryFee: 1.99,
    minOrder: 8,
    distance: '0.8 km',
    cover: 'https://images.unsplash.com/photo-1572802419224-296b0aeee0d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxidXJnZXJ8ZW58MHx8fHwxNzc5MjE1MTQ4fDA&ixlib=rb-4.1.0&q=85',
    logo: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&w=120&q=70',
    tags: ['Burgers', 'Fries', 'Shakes'],
    promo: null,
  },
  {
    id: 'v4',
    name: 'El Mariachi Tacos',
    category: 'restaurants',
    cuisine: 'Mexican',
    rating: 4.7,
    reviews: 612,
    deliveryTime: '20–30 min',
    deliveryFee: 2.49,
    minOrder: 12,
    distance: '1.6 km',
    cover: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHx0YWNvc3xlbnwwfHx8fDE3NzkyMTUxNTV8MA&ixlib=rb-4.1.0&q=85',
    logo: 'https://images.pexels.com/photos/33614207/pexels-photo-33614207.jpeg?auto=compress&cs=tinysrgb&w=120',
    tags: ['Tacos', 'Burritos', 'Mexican'],
    promo: 'Buy 1 Get 1',
  },
  {
    id: 'v5',
    name: 'Green Bowl Kitchen',
    category: 'restaurants',
    cuisine: 'Healthy',
    rating: 4.8,
    reviews: 990,
    deliveryTime: '20–30 min',
    deliveryFee: 2.99,
    minOrder: 12,
    distance: '1.9 km',
    cover: 'https://images.unsplash.com/photo-1597958792579-bd3517df6399?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxib3dsfGVufDB8fHx8MTc3OTIxNTE1NXww&ixlib=rb-4.1.0&q=85',
    logo: 'https://images.unsplash.com/photo-1602881916963-5daf2d97c06e?crop=entropy&cs=srgb&fm=jpg&w=120&q=70',
    tags: ['Salads', 'Bowls', 'Vegan'],
    promo: null,
  },
  {
    id: 'v6',
    name: 'Bistro Lumière',
    category: 'restaurants',
    cuisine: 'French',
    rating: 4.9,
    reviews: 430,
    deliveryTime: '30–40 min',
    deliveryFee: 4.99,
    minOrder: 20,
    distance: '3.1 km',
    cover: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwZm9vZHxlbnwwfHx8fDE3NzkxMjc5OTh8MA&ixlib=rb-4.1.0&q=85',
    logo: 'https://images.unsplash.com/photo-1482049016688-2d3e1b311543?crop=entropy&cs=srgb&fm=jpg&w=120&q=70',
    tags: ['French', 'Fine dining'],
    promo: null,
  },
  {
    id: 'v7',
    name: 'FreshMart Grocers',
    category: 'grocery',
    cuisine: 'Supermarket',
    rating: 4.7,
    reviews: 3120,
    deliveryTime: '15–25 min',
    deliveryFee: 1.49,
    minOrder: 10,
    distance: '0.6 km',
    cover: 'https://images.unsplash.com/photo-1542838132-92c53300491e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxncm9jZXJ5fGVufDB8fHx8MTc3OTIxNTE0MXww&ixlib=rb-4.1.0&q=85',
    logo: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&w=120&q=70',
    tags: ['Produce', 'Dairy', 'Pantry'],
    promo: '10% off',
  },
  {
    id: 'v8',
    name: 'DailyNeeds Market',
    category: 'grocery',
    cuisine: 'Supermarket',
    rating: 4.5,
    reviews: 1810,
    deliveryTime: '20–30 min',
    deliveryFee: 1.99,
    minOrder: 12,
    distance: '1.1 km',
    cover: 'https://images.unsplash.com/photo-1550989460-0adf9ea622e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxncm9jZXJ5fGVufDB8fHx8MTc3OTIxNTE0MXww&ixlib=rb-4.1.0&q=85',
    logo: null,
    tags: ['Groceries', 'Snacks', 'Drinks'],
    promo: null,
  },
  {
    id: 'v9',
    name: 'CarePlus Pharmacy',
    category: 'pharmacy',
    cuisine: 'Health',
    rating: 4.8,
    reviews: 540,
    deliveryTime: '25–40 min',
    deliveryFee: 2.99,
    minOrder: 5,
    distance: '1.8 km',
    cover: 'https://images.unsplash.com/photo-1593504049359-74330189a345?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxwaXp6YXxlbnwwfHx8fDE3NzkyMTUxNDh8MA&ixlib=rb-4.1.0&q=85',
    logo: null,
    tags: ['Medicine', 'Wellness', 'OTC'],
    promo: null,
  },
];

// Helper builder for menu items
const dish = (id, name, desc, price, img, popular = false, veg = false) => ({
  id, name, description: desc, price, image: img, popular, veg,
});

export const MENUS = {
  v1: {
    sections: [
      {
        title: 'Popular',
        items: [
          dish('v1-1', 'Margherita Classica', 'San Marzano tomato, fresh mozzarella, basil', 14.5, 'https://images.unsplash.com/photo-1513104890138-7c749659a591?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true, true),
          dish('v1-2', 'Pepperoni Forte', 'Spicy pepperoni, mozzarella, oregano', 16.9, 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true),
          dish('v1-3', 'Quattro Formaggi', 'Four cheese blend with truffle oil', 18.0, 'https://images.unsplash.com/photo-1593504049359-74330189a345?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', false, true),
        ],
      },
      {
        title: 'Pasta',
        items: [
          dish('v1-4', 'Spaghetti Carbonara', 'Egg, guanciale, pecorino, black pepper', 15.5, 'https://images.unsplash.com/photo-1482049016688-2d3e1b311543?crop=entropy&cs=srgb&fm=jpg&w=500&q=70'),
          dish('v1-5', 'Penne Arrabbiata', 'Tomato, garlic, chili, parsley', 13.0, 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', false, true),
        ],
      },
    ],
  },
  v2: {
    sections: [
      {
        title: 'Signature Rolls',
        items: [
          dish('v2-1', 'Dragon Roll', 'Eel, cucumber, avocado, eel sauce', 18.9, 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true),
          dish('v2-2', 'Spicy Tuna Crunch', 'Tuna, sriracha, tempura flakes', 16.5, 'https://images.unsplash.com/photo-1553621042-f6e147245754?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true),
          dish('v2-3', 'Veggie Garden Roll', 'Avocado, cucumber, carrot, mango', 12.0, 'https://images.pexels.com/photos/37260689/pexels-photo-37260689.jpeg?auto=compress&cs=tinysrgb&w=500', false, true),
        ],
      },
      {
        title: 'Nigiri & Sashimi',
        items: [
          dish('v2-4', 'Salmon Nigiri (4pc)', 'Fresh Atlantic salmon', 11.0, 'https://images.unsplash.com/photo-1553621042-f6e147245754?crop=entropy&cs=srgb&fm=jpg&w=500&q=70'),
          dish('v2-5', 'Tuna Sashimi (6pc)', 'Premium bluefin tuna', 19.0, 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?crop=entropy&cs=srgb&fm=jpg&w=500&q=70'),
        ],
      },
    ],
  },
  v3: {
    sections: [
      {
        title: 'Smash Burgers',
        items: [
          dish('v3-1', 'Classic Smash', 'Double patty, american cheese, pickles, onion', 11.5, 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true),
          dish('v3-2', 'Bacon Inferno', 'Smoky bacon, jalapeños, chipotle mayo', 13.9, 'https://images.unsplash.com/photo-1572802419224-296b0aeee0d9?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true),
          dish('v3-3', 'Mushroom Swiss', 'Sautéed mushrooms, swiss, truffle aioli', 12.9, 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&w=500&q=70'),
        ],
      },
      {
        title: 'Sides & Shakes',
        items: [
          dish('v3-4', 'Crispy Fries', 'Hand-cut, sea salt', 4.5, 'https://images.unsplash.com/photo-1572802419224-296b0aeee0d9?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', false, true),
          dish('v3-5', 'Vanilla Shake', 'Creamy vanilla bean shake', 6.0, 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', false, true),
        ],
      },
    ],
  },
  v4: {
    sections: [
      {
        title: 'Street Tacos',
        items: [
          dish('v4-1', 'Carne Asada Trio', 'Grilled steak, cilantro, onion, lime', 12.5, 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true),
          dish('v4-2', 'Al Pastor', 'Marinated pork, pineapple', 11.0, 'https://images.pexels.com/photos/33614207/pexels-photo-33614207.jpeg?auto=compress&cs=tinysrgb&w=500', true),
          dish('v4-3', 'Veggie Fiesta', 'Roasted peppers, beans, queso fresco', 9.5, 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', false, true),
        ],
      },
    ],
  },
  v5: {
    sections: [
      {
        title: 'Power Bowls',
        items: [
          dish('v5-1', 'Mediterranean Bowl', 'Quinoa, falafel, hummus, tzatziki', 13.5, 'https://images.unsplash.com/photo-1597958792579-bd3517df6399?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true, true),
          dish('v5-2', 'Buddha Bowl', 'Brown rice, tofu, edamame, ginger', 12.9, 'https://images.unsplash.com/photo-1602881916963-5daf2d97c06e?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true, true),
        ],
      },
    ],
  },
  v6: {
    sections: [
      {
        title: 'Mains',
        items: [
          dish('v6-1', 'Coq au Vin', 'Slow-braised chicken, red wine, mushrooms', 26.0, 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true),
          dish('v6-2', 'Steak Frites', 'Aged ribeye, herb butter, pommes frites', 32.0, 'https://images.unsplash.com/photo-1482049016688-2d3e1b311543?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true),
        ],
      },
    ],
  },
  v7: {
    sections: [
      {
        title: 'Fresh Produce',
        items: [
          dish('v7-1', 'Organic Avocados (4)', 'Hass, ripe & ready', 6.99, 'https://images.unsplash.com/photo-1542838132-92c53300491e?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true, true),
          dish('v7-2', 'Strawberries 500g', 'Sweet, locally sourced', 4.49, 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true, true),
        ],
      },
      {
        title: 'Pantry',
        items: [
          dish('v7-3', 'Sourdough Loaf', 'Artisan bakery, baked daily', 5.5, 'https://images.unsplash.com/photo-1550989460-0adf9ea622e2?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', false, true),
          dish('v7-4', 'Organic Eggs (12)', 'Free-range, pasture raised', 7.99, 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&w=500&q=70'),
        ],
      },
    ],
  },
  v8: {
    sections: [
      {
        title: 'Essentials',
        items: [
          dish('v8-1', 'Whole Milk 1L', 'Farm-fresh dairy', 2.49, 'https://images.unsplash.com/photo-1550989460-0adf9ea622e2?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', true, true),
          dish('v8-2', 'Pasta Penne 500g', 'Italian durum wheat', 1.99, 'https://images.unsplash.com/photo-1542838132-92c53300491e?crop=entropy&cs=srgb&fm=jpg&w=500&q=70', false, true),
        ],
      },
    ],
  },
  v9: {
    sections: [
      {
        title: 'Over-the-counter',
        items: [
          dish('v9-1', 'Pain Relief Tablets', 'Fast-acting, 24 ct', 8.99, 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&w=500&q=70'),
          dish('v9-2', 'Vitamin C 1000mg', 'Immune support, 60 ct', 12.5, 'https://images.unsplash.com/photo-1542838132-92c53300491e?crop=entropy&cs=srgb&fm=jpg&w=500&q=70'),
        ],
      },
    ],
  },
};

export const SAMPLE_ORDERS = [
  {
    id: 'SD-10293',
    vendorId: 'v1',
    vendorName: 'Napoli Pizza Co.',
    status: 'on_the_way',
    placedAt: '2025-07-19T18:21:00Z',
    eta: '14 min',
    items: [
      { id: 'v1-1', name: 'Margherita Classica', qty: 1, price: 14.5 },
      { id: 'v1-4', name: 'Spaghetti Carbonara', qty: 1, price: 15.5 },
    ],
    subtotal: 30.0,
    deliveryFee: 2.99,
    total: 32.99,
    address: '142 King St, Brooklyn',
    driver: { name: 'Mateo R.', rating: 4.9, vehicle: 'Scooter • XB-902' },
  },
  {
    id: 'SD-10241',
    vendorId: 'v3',
    vendorName: 'Smash & Stack Burgers',
    status: 'delivered',
    placedAt: '2025-07-15T13:02:00Z',
    eta: null,
    items: [
      { id: 'v3-1', name: 'Classic Smash', qty: 2, price: 11.5 },
      { id: 'v3-4', name: 'Crispy Fries', qty: 1, price: 4.5 },
    ],
    subtotal: 27.5,
    deliveryFee: 1.99,
    total: 29.49,
    address: '142 King St, Brooklyn',
    driver: { name: 'Aria T.', rating: 4.8, vehicle: 'Bike' },
  },
];

export const ORDER_STATUSES = [
  { key: 'placed', label: 'Order placed' },
  { key: 'confirmed', label: 'Confirmed by store' },
  { key: 'preparing', label: 'Preparing your order' },
  { key: 'on_the_way', label: 'Out for delivery' },
  { key: 'delivered', label: 'Delivered' },
];
